import {inject, Injectable} from "@angular/core";
import {ProjectTeamOverviewService} from "../services/project-team-overview.service";
import {BehaviorSubject, EMPTY, expand, finalize, map, reduce, switchMap, tap, toArray} from "rxjs";
import {ProjectRequestDto} from "../models/project-request.dto";
import { DataManipulationService } from "src/app/services/data-manipulation.service";

@Injectable({
  providedIn: 'root'
})
export class PTOFacade {
    private projectApi = inject(ProjectTeamOverviewService);
    private data = inject(DataManipulationService);

    private projectsSubject = new BehaviorSubject<any>([]);
    readonly projects$ = this.projectsSubject.asObservable();
    private loadingSubject = new BehaviorSubject<boolean>(false);
    readonly loading$ = this.loadingSubject.asObservable();

    loadProjects(payload: ProjectRequestDto): void {
      this.loadingSubject.next(true);

      this.projectApi.getIndicatorInterval().pipe(
        switchMap(intervals => {
          const firstPayload: ProjectRequestDto = {
            ...payload,
            params: {
              ...payload.params,
              page: 1
            }
          };

          return this.projectApi.loadProjects(firstPayload).pipe(
            expand((response: any) => {
              if (response.page < response.pageCount) {
                return this.projectApi.loadProjects({
                  ...payload,
                  params: {
                    ...payload.params,
                    page: response.page + 1
                  }
                });
              }
              return EMPTY;
            }),

            map((response: any) =>
              response.pojects.map((project: any) => ({
                ...project,
                project: {
                  ...project.project,
                  color: this.getColorForScore(project.score, intervals),
                  fadeColor: this.getRgba(this.getColorForScore(project.score, intervals), 0.1),
                  colorLoaded: true
                }
              }))
            ),
            toArray(),
            map(pages => pages.flat())
          );
        }),
        finalize(() => {
          this.loadingSubject.next(false);
        })
      )
      .subscribe(projects => {
        this.projectsSubject.next(projects);
      });
    }

    private getRgba(hex: string, alpha: number = 1): string {
      hex = hex.replace('#', '');
      if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
      if (hex.length !== 6) throw new Error('Hex code invalid');

      const r = parseInt(hex.slice(0, 2), 16);
      const g = parseInt(hex.slice(2, 4), 16);
      const b = parseInt(hex.slice(4, 6), 16);

      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    private getColorForScore(score: number, intervals: any[]): string {
      const interval = intervals.find(interval => (interval.min <= score && score <= interval.max));
      //@ts-ignore
      return this.data.colors[interval.indicatorColor.color] ?? this.data.colors.grey;
    }
}
